import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=8d360808&scoped=true&"
import script from "./BaseInfo.vue?vue&type=script&lang=ts&"
export * from "./BaseInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInfo.vue?vue&type=style&index=0&id=8d360808&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d360808",
  null
  
)

export default component.exports